<template>
    <section class="recent-wrapper">
        <div class="container">
            <div class="form-bank-con">
                <div class="choose-payment-method click-choose-payment-method-sec" v-if="parentPaymentsList">
                    <h4 v-if="!parentPaymentsList">{{ $t('no-method-available','No payment method available. Contact customer service!!') }}</h4>
                    <h4 v-else>{{ $t('Choose-payment-method','Choose a payment method') }}</h4>
                    <div class="market-btn-tablist online-tabs-sec">
                        <ul class="market-button market_btn_list nav nav-tabs" id="myTab" role="tablist">

                            <!-- <li class="left market-btn" v-if="$siteSettings?.data?.social_link && ($siteSettings?.data?.social_link?.whatsappno1 || $siteSettings?.data?.social_link?.whatsappno2)">
                                <button id="hdfc-tab" @click="gotoWhatsappDeposit()">
                                    <div class="recent-bank from-bank">
                                        <div class="bank-icon mb-0 mt-1">
                                            <img loading="lazy" src="@/assets/images/whatsapp-deposit.png" alt="whatsapp-deposit" />
                                        </div>
                                        <div class="bank-con">
                                            <h6>Whatsapp Deposit</h6>
                                        </div>
                                    </div>
                                    <input class="form-check-input flexRadioDefault-sec" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                </button>
                            </li> -->

                            <li class="left market-btn" v-for="(paymentData, payment) in parentPaymentsList" :key="payment" @click="choosePaymentMethod(paymentData, payment)">
                                <button id="hdfc-tab" :class="{ active: activeTab === payment }" data-bs-toggle="tab" data-bs-target="#hdfc" type="button" role="tab" aria-controls="hdfc" aria-selected="false">
                                    <div class="get-bonus-sec" v-if="paymentBonusRef?.[paymentData?.[0]?.method_id]">Get {{ paymentBonusRef?.[paymentData?.[0]?.method_id] }}% Bonus</div>
                                    <div class="recent-bank from-bank">
                                        <div class="bank-icon">
                                            <img :src="methodIcons[payment]" alt="" loading="lazy" />
                                        </div>
                                        <div class="bank-con">
                                            <h6>{{ payment }}</h6>
                                        </div>
                                    </div>
                                    <input class="form-check-input flexRadioDefault-sec" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="lotbet-new-every-bonus-wrapper" v-if="hasFirstDepositBonus">
                <div class="lotbet-bonus-card clickbet-first-login-bonus">
                    <div class="lotbet-star-decoration top-left">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration bottom-right">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration top-center-right">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration bottom-left">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    
                    <div class="lotbet-bonus-content-container">
                        <div class="lotbet-bonus-icon"></div>
                        
                        <div class="lotbet-bonus-text-group">
                            <div class="lotbet-bonus-description">You will get <strong>{{ hasFirstDepositBonus.percentage }}% bonus</strong> on first deposit.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lotbet-new-every-bonus-wrapper" v-if="hasEveryDepositBonus">
                <div class="lotbet-bonus-card clickbet-every-login-bonus">
                    <div class="lotbet-star-decoration top-left">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration bottom-right">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration top-center-right">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    <div class="lotbet-star-decoration bottom-left">
                        <svg width="24" height="24" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group"><g id="star"><path id="Vector" d="M0.405762 6.38867C10.1454 10.6987 10.1454 10.6987 14.7051 1.00031C10.1454 10.6987 10.1454 10.6987 19.885 15.0087C10.1454 10.6987 10.1454 10.6987 5.58558 20.397C10.1454 10.6987 10.1454 10.6987 0.405762 6.38867Z" fill="#FFF"></path></g></g></svg>
                    </div>
                    
                    <div class="lotbet-bonus-content-container">
                        <div class="lotbet-bonus-icon lotbet-bonus-icon-gift1"></div>
                        
                        <div class="lotbet-bonus-text-group">
                            <div class="lotbet-bonus-description">You will get <strong>{{ hasEveryDepositBonus.percentage }}% bonus</strong> on every deposit.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bank-details-tabs-content click-bank-detail-content-sec p-gap-35" v-if="paymentDetailsList?.length && paymentDetailsList?.[0]?.method != 'social'">
                 <div class="bank_sec_cl">
                    <template v-if="accountDetails && !isPaymentGateway">
                        <div class="bank-deposit-heading paragraph-heading" v-if="currentPaymentId == 'bank'">
                            <p>{{ $t('you-can-through-bank-transfer','You can add through a bank transfer') }}</p>
                        </div>
                        <div class="upi-card-list">
                            <div class="upi-payment-content">
                                <BankAccountDetails :bankAccounts="paymentDetailsList" :s3Url="AccountS3Url" @change-account="changeAccount" v-if="currentPaymentId == 'bank'"/>
                                <UpiAccountDetails :upiAccounts="paymentDetailsList" @change-account="changeAccount" :s3Url="AccountS3Url" v-else/>
                            </div>
                        </div>
                    </template>
                    <div class="withdraw-sec add-account-sec" v-if="isPaymentGateway">
                        <div class="hide-input-sec payment-gateway-sec" v-if="paymentDetailsList?.[0]?.method != 'social'">
                            <span>
                                Pay using our payemnt gateway
                            </span>
                            <span class="matka-but-dflex pg-btn">
                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                            </span>
                        </div>
                    </div>
                    <template v-else>
                        <div class="bank-upi-sec" v-if="accountDetails">
                            <div class="withdraw-sec add-account-sec" ref="utrSection">
                                <div class="hide-input-sec">
                                    <div class="number-sec row">
                                       <div class="number-header col-12 thm-heading d-inline-block">
                                           <label class="info-sec">
                                                   {{ $t('upload-screenshot','Upload a Screenshot') }}*
                                               <span class="info-sec-icon">
                                                   <img src="@/assets/images/info-iconn.svg" alt="info-iconn" loading="lazy" />
                                                   <div class="info-list">
                                                   <ul>
                                                       <li><span>{{ $t('upload-transaction-screenshot','Upload transaction screenshot') }}</span></li>
                                                   </ul>
                                                   </div>
                                               </span>
                                           </label>
                                           <!-- <p class="ss_shot_txt">
                                               {{ $t('take-screenshot-payment-success','Take a screenshot of the payment success screen and upload it below') }}
                                           </p> -->
                                           <div class="file-upload-sec"  v-if="!previewImage">
                                               <label for="file" class="file-upload">
                                                   <span><img src="@/assets/images/file-icon.svg" alt="file-icon" loading="lazy" /></span>
               
                                                   <h6 class="text-dark">{{ $t('upload-screenshot','Upload screenshot') }}</h6>
                                               </label>
                                               <input @change="onUploadImageHandler($event)" accept="image/png, image/jpeg, image/jpg, image/gif" class="form-control profit-input d-none" 
                                                   type="file" name="file" id="file" />
                                           </div>
                                           <span class="text-danger" v-if="init.transaction_image_url && !uploadedImage">Please Upload The Image.</span>
                                           <div class="fileList" v-if="previewImage">
                                               <img loading="lazy" class="fileList-img" :src="previewImage" alt="file-list"/>
                                               <button class="add-utr-again" @click="removeImage()">
                                                   &#10006;
                                               </button>
                                               <div class="loader_timer" v-if="utrLoader">
                                                   <div class="loader_deposit">
                                                   </div>
                                                   <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                       {{ timerValue }}
                                                   </text>
                                               </div>
                                           </div>
                                            <div class="paymentProofFileUploadStatus" v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="bank-withdaw-sec" v-if="accountDetails && accountDetails?.method == 'wallet'">
                            <div class="withdraw-sec">
                                <div class="back-modal utr_parent_cl">
                                    <div class="number-sec amount-input">
                                        <div class="number-header show">
                                            <label class="info-sec">Wallet Deposit Amount ( at x{{ accountDetails.multiplier_value }})</label>
                                            <input class="form-control profit-input" disabled :placeholder="`${depositAmount/accountDetails?.multiplier_value} ${accountDetails?.method_name}`" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                         
                        <div class="bank-withdaw-sec" v-if="accountDetails">
                            <div class="withdraw-sec">
                                <div class="back-modal utr_parent_cl">
                                    <div class="number-sec amount-input">
                                    <div class="number-header show">
                                        <label class="info-sec">{{ $t('enter-utr-number','UTR Number') }}<span v-if="accountDetails?.method != 'wallet'">*</span>
                                           <span class="info-sec-icon">
                                                <img src="@/assets/images/info-iconn.svg" alt="info-iconn" loading="lazy" />
                                                <div class="info-list">
                                                <ul>
                                                    <li><span>{{ $t('enter-generated-utr-number-from-transaction','Enter generated utr number from transaction') }}</span></li>
                                                </ul>
                                                </div>
                                            </span>
                                       </label>
                                        <!-- <p class="ss_shot_txt">
                                            {{ $t(utrMsg.langKey, utrMsg.msg) }}
                                        </p> -->
                                        
                                        <input class="form-control profit-input" :maxlength="accountDetails?.method != 'wallet' ? 15 : 128" v-model="manual_utr" @input="sanitizeInput(), has_edited_utr = 1" :placeholder="$t('enter-utr-number','Enter UTR number')" />
                                        <span class="text-danger" v-if="init.utr && !manual_utr.length && accountDetails?.method != 'wallet'">Please Enter UTR Number.</span>
                                        <span class="text-danger" v-else-if="init.utr && manual_utr.length < 10 && accountDetails?.method != 'wallet'">UTR Number Must Be 10 to 15 Digits</span>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bank-btn" v-if="accountDetails" ref="sbtBtn">
                            <button @click="submitDepositAmountApi()" type="button" class="thm-but" id="account-successfully">{{ $t('submit-request','Submit Request') }}</button>
                        </div>
                    </template>
                 </div>
             </div>
        </div>
   </section>
</template>

<script setup>
import { useStore } from 'vuex'
import { defineAsyncComponent, computed, ref, inject, reactive, onMounted,getCurrentInstance } from 'vue';
import { getParentPaymentsMethods, 
    onUploadImage, 
    submitDepositAmount, 
    getPaymentGatewayUrl,
    createSharedComputedForDepositPayment
} from '@template/utils';
const BankAccountDetails = defineAsyncComponent(() => import('../components/BankAccountDetails.vue'));
const UpiAccountDetails = defineAsyncComponent(() => import('../components/UpiAccountDetails.vue'));
const { $t, $errorToast,$siteSettings,$helper,$successToast } = getCurrentInstance().proxy;
const store = useStore();
const walletConfig = inject('walletConfig')
const parentPaymentsList = ref(null);
const s3Url = ref(null);
const bankS3url = ref(null);
const utrSection = ref(null);
const activeTab = ref(null);
const currentPaymentId = ref(null);
const paymentDetailsList = ref(null);
const uploadedImage = ref(null);
const manual_utr = ref(null);
const tesseract_utr = ref(null);
const previewImage = ref(null);
const accountDetails = ref(null);
const sbtBtn = ref(null);
const utrMsg = reactive({
    langKey: 'enter-utr',
    msg: "Kindly enter UTR Number manually for fast deposit."
});

const AccountS3Url = ref(null);
const t = ref(6);                    
const interval = ref(30);           
const angle = ref(0);               
const angle_increment = ref(360 / 9);
const intervalCounter = ref(0);
const timerValue = ref(9);           
const timer = ref(null);   

const utrLoader = ref(false);

const init = reactive({
    utr: false,
    transaction_image_url: false
});

const has_edited_utr = ref(0);
const isPaymentGateway = ref(null);
const paymentProofFileUploadStatus = ref('');
let paymentBonusRef = ref(null)

const depositAmount = computed(() => store.getters.depositAmount);
const bonusData = computed(() => store.getters.bonusData);

 const hasFirstDepositBonus = computed(() => {
    return bonusData.value.find(bd => bd.bonusType == 'first deposit')
 })   
 const hasEveryDepositBonus = computed(() => {
    return bonusData.value.find(bd => bd.bonusType == 'every deposit')
 })  

 const methodIcons = computed(() => {
        const iconObj = {}
        walletConfig.value?.payment_method?.forEach(element => {
            iconObj[element.method_name] = element.icon
        })

        walletConfig.value?.bank_list?.forEach(element => {
            iconObj[element.bank_name] = element.icon
        })

        return iconObj
    });


onMounted(() => {
    getParentPaymentsMethodsHandler();
});

const toggleInit = (bool) => {
    init.utr = bool;
    init.transaction_image_url = bool;
};

const startTimer = () => {
    utrLoader.value = true;
    $helper.scrollToElement(utrSection.value);
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
    if (timer.value) {
        clearInterval(timer.value);
    }

    timer.value = setInterval(() => {
        intervalCounter.value++;

        angle.value =
            (intervalCounter.value /
                (t.value * (1000 / interval.value))) *
            360;

        timerValue.value =
            t.value - Math.floor((angle.value / 360) * t.value);

        if (timerValue.value <= 0) {
            resetTimer();
            utrLoader.value = false;
        }
    }, interval.value);
};


const getParentPaymentsMethodsHandler = async (reconnectTry = 0) => {
    try {
        let response = await getParentPaymentsMethods(
            reconnectTry,
            depositAmount.value
        );
        if (response?.data) {
            parentPaymentsList.value = response.data;

            let nonSocialStartIndex = response?.nonSocialStartIndex;

            activeTab.value = Object.keys(parentPaymentsList.value)[nonSocialStartIndex];

            choosePaymentMethod(
                parentPaymentsList.value[activeTab.value],
                activeTab.value
            );
            const { paymentBonus } = createSharedComputedForDepositPayment({bonusData: bonusData.value})
            paymentBonusRef = computed(paymentBonus);
        }
    } catch (error) {
        $errorToast(error);
    }
};


const choosePaymentMethod = (payment, index) => {
    clearPaymentSlip();
    toggleInit(false);
        activeTab.value = index;
        paymentDetailsList.value = payment;
    if (payment?.[0]?.method === 'social') {
        const socialNumber = payment?.[0]?.social_payment_number;
        const socialLink = payment?.[0]?.social_payment_link;

        if (socialNumber?.length && socialLink?.length) {
            const choice = Math.random() < 0.5 ? 'number' : 'link';

            if (choice === 'number') {
                if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                    window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                    window.open(`https://t.me/${socialNumber}`, 'blank');
                }
            } else {
                window.open(socialLink, 'blank');
            }
            return;
        }

        if (socialNumber?.length) {
            if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
            } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                window.open(`https://t.me/${socialNumber}`, 'blank');
            }
            return;
        }

        if (socialLink?.length) {
            window.open(socialLink, 'blank');
            return;
        }

        $errorToast($t('no-social-payment-number', 'No social payment number available'));
        return;
    }

    if (payment?.[0]?.method === 'payment_gateway') {
        isPaymentGateway.value = true;
        paymentDetailsList.value = payment;
        return;
    }
    currentPaymentId.value = payment?.[0]?.method;
    AccountS3Url.value = payment?.qrCodeUrl;
    accountDetails.value = paymentDetailsList.value?.[0];
    isPaymentGateway.value = false;
};

const submitDepositAmountApi = async () => {
    try {
        toggleInit(true);
        if (accountDetails.value?.method !== 'wallet' && manual_utr.value?.length < 11) {
            return;
        }
        const response = await  submitDepositAmount({
            accountDetails: accountDetails.value,
            uploadedImage: uploadedImage.value,
            depositAmount: depositAmount.value,
            manual_utr: manual_utr.value,
            removeImage: removeImage,
            has_edited_utr: has_edited_utr.value,
        });

    } catch (error) {
        $errorToast(error);
    }
};

const resetTimer = () => {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
};


const onUploadImageHandler = async (event) => {
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const file = event.target.files[0];
        previewImage.value = URL.createObjectURL(file);
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
        const response = await onUploadImage({
            event,
            depositAmount: depositAmount.value,
            startTimer,        
            resetTimer,        
            sbtBtn: sbtBtn.value, 
            paymentProofFileUploadStatus          
        });

        if (response) {
             if(!response?.manual_utr){
                    paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }
            manual_utr.value = response?.manual_utr;
            if (response?.utrMsg) {
                Object.assign(utrMsg, response.utrMsg);
            }
            uploadedImage.value = response?.uploadedImage;
            previewImage.value = response?.previewImage;
            tesseract_utr.value = response?.tesseract_utr;
            utrLoader.value = false;
        } 
        else {
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            previewImage.value = null;
        }

    } catch (error) {
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        previewImage.value = null;
        $errorToast(error);
    }
     finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
};

const removeImage = () => {
    uploadedImage.value = null;
    previewImage.value = null;
    has_edited_utr.value = 0;
    manual_utr.value = '';
};

const clearPaymentSlip = () => {
    uploadedImage.value = null;
    previewImage.value = null;
    manual_utr.value = '';
    has_edited_utr.value = 0;
};

const changeAccount = (data) => {
    accountDetails.value = data;
    clearPaymentSlip();
    toggleInit(false);
};

const sanitizeInput = () => {
    manual_utr.value = manual_utr.value?.replace(/\D+/g, '') || '';
};

const goToPaymentGateway = async () => {
    try {
        const response = await getPaymentGatewayUrl(
            depositAmount.value,
            paymentDetailsList.value[0].master_account_id
        );
    } catch (error) {
        $errorToast(error);
    }
};
const gotoWhatsappDeposit = () => {
    const number =
        $siteSettings?.data?.social_link?.whatsappno1 ||
        $siteSettings?.data?.social_link?.whatsappno2;

    window.open(`https://wa.me/${number}`, '_blank');
};







</script>


<style scoped>
.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(65 188 160 / 14%);
  height: 100%;
  width: 100%;
}

.timer {
    position: absolute;
    top: 0;
    right: 0;
}

.withdraw-sec.add-account-sec {
    position: relative;
}

.timer svg {
    top: 42%;
    left: 42%;
    position: absolute;
    width: 237px;
    height: 237px;
    margin-left: -40px;
    margin-top: -40px;
}

.tab-content {
    margin-bottom: 63px;
}

.lotbet-new-every-bonus-wrapper {
    padding: 2px;
    max-width: 500px;
    margin: 0 auto;
}

.lotbet-bonus-card {
    background: linear-gradient(90deg, #134146 10.83%,#2fa0ac 130%);
    border-radius: 10px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-family: cursive;
    position: relative;
    overflow: hidden;
}
.clickbet-first-login-bonus{
    background: linear-gradient(90deg, #134146 10.83%,#2fa0ac 130%);
}
.clickbet-every-login-bonus {
    background: linear-gradient(90deg, #000000 10.83%, #0099aa 130%);
}
.lotbet-star-decoration {
    position: absolute;
    opacity: 0.73;
}
.lotbet-star-decoration.top-left {
    top: -2px;
    left: 1px;
}

.lotbet-star-decoration.bottom-right {
    bottom: -5px; 
    right: 5px;
}

.lotbet-star-decoration.top-center-right {
    top:5%;
    right: 20%;
}

.lotbet-star-decoration.bottom-left {
    bottom: -5px;
    left: 10%;
}

.lotbet-bonus-content-container {
    display: flex;
    align-items: center;
}

.lotbet-bonus-icon {
    width: 45px;
    height: 45px;
    margin-right: 10px;
    background-image: url('@/assets/images/gift.svg');
    background-size: cover;
    flex-shrink: 0;
}

.lotbet-bonus-icon-gift1 {
    background-image: url('@/assets/images/gift1.svg');
}
.lotbet-bonus-text-group {
    display: flex;
    flex-direction: column;
    text-align: left; 
}

.lotbet-bonus-description {
    font-size: 13px;
    opacity: 1;
    line-height: normal;
}

</style>

<style>
.team-list-wet {
    overflow: scroll;
}

.code-list .team-list-sec ul {
    width: 90% !important;
}

.payment-gateway-sec {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.pg-btn {
    margin-top: 10px;
}

.paymentProofFileUploadStatus {
  color: #333;
  font-size: 12px;
  margin-top: 5px;
}

</style>